import React from 'react';

/**
 * ShipitNow wordmark — green "Shipit" + orange "Now".
 *
 * Uses inline SVG so it stays crisp at every size and respects currentColor /
 * accent props if a caller wants a tinted variant.
 */
const Wordmark = ({ className = '', height = 28, withTagline = false, accent = 'normal', testid = 'shipitnow-wordmark' }) => {
  // Brand palette (2026-08 refresh): royal blue "Shipit" + orange "Now",
  // matching the raster logo at /shipitnow-logo.png.
  const blue = accent === 'light' ? '#60A5FA' : '#1E4FA6';
  const orange = accent === 'light' ? '#fb923c' : '#F1671B';
  return (
    <span className={`inline-flex items-center select-none ${className}`} data-testid={testid}>
      <svg viewBox="0 0 220 56" height={height} fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="ShipitNow">
        {/* Signature swoosh under the wordmark */}
        <path d="M2 50 L210 50" stroke={blue} strokeWidth="3" strokeLinecap="round" opacity="0.65" />
        <text x="0" y="40" fontFamily="'Anton','Bebas Neue',Impact,system-ui,sans-serif" fontWeight="900" fontStyle="italic" fontSize="42" letterSpacing="-0.5">
          <tspan fill={blue}>Shipit</tspan>
          <tspan fill={orange}>Now</tspan>
        </text>
      </svg>
      {withTagline && (
        <span className="ml-3 text-[10px] uppercase tracking-widest font-semibold" style={{ color: orange }}>
          Anything · Anytime · Delivered
        </span>
      )}
    </span>
  );
};

export default Wordmark;
